import { Expose } from "@nts/std/serialization";
import { SimpleFieldMetaData } from './simple-field-meta-data';
import { FieldTypes } from "@nts/std/types";
import type { CustomFieldMetaDataInterface } from '@nts/std/interfaces';

export class CustomFieldMetaData extends SimpleFieldMetaData implements CustomFieldMetaDataInterface {

  @Expose()
  uniqueId: string;

  override getFieldType(): FieldTypes {
    return FieldTypes.Custom;
  }
}
